/* React-Redux */
import { createAsyncThunk } from "@reduxjs/toolkit";

/* Axios */
import axios, { HttpStatusCode } from "axios";

/* Utils */
import axiosInterceptor from "src/utils/helper/axios-interceptor";
import { LoginRequestDto } from "src/utils/dto/auth/LoginRequestDto";
import { createCookies } from "src/utils/helper/cookies";
import { ClientError } from "src/utils/status-handling/ClientError";

/* Interfaces */
import {
  AuthProps,
  TwoFaProps,
} from "src/shared/interfaces/common/Auth";
import { BaseLoginProps } from "src/shared/interfaces/api/Login";

export const loginWithCredentials = createAsyncThunk<
  AuthProps,
  BaseLoginProps,
  { rejectValue: ClientError | TwoFaProps }
>(
  "loginWithCredentials",
  async (
    credentials: BaseLoginProps,
    { rejectWithValue }
  ) => {
    const dto = new LoginRequestDto(credentials);
    const requestParams = dto.toApi();
    const { usernameEmail, password } = dto.toObject();

    try {
      const response = await axiosInterceptor.post(
        "/login_with_credentials",
        requestParams
      );
      return createCookies(response);
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const detail = error.response?.data.detail;

        if (
          error.response?.status ===
          HttpStatusCode.BadRequest
        ) {
          return rejectWithValue({
            qrCode: detail.qrCode,
            otpUrl: detail.otpUrl,
            qrCodeRequired: detail.qrCodeRequired,
            twoFaRequired: detail.twoFaRequired,
            credentials: {
              usernameEmail: usernameEmail,
              password: password,
            },
          } satisfies TwoFaProps);
        } else {
          return rejectWithValue(
            ClientError.invalidCredentials()
          );
        }
      }
      return rejectWithValue(ClientError.internal());
    }
  }
);
